var ViewFilters;
(function (ViewFilters) {
    debounceByID('view-filters', () => {
        const $filterGroups = document.querySelectorAll('[data-view-filters]');
        $filterGroups.forEach(($filterGroup) => {
            $filterGroup.innerHTML = '';
            initFilterGroup($filterGroup);
        });
    }, 500)();
    function initFilterGroup($filterGroup) {
        const $src = $filterGroup.closest('.component').querySelector('.view-filters form');
        console.log('PROVA');
        if ($src) {
            const $submit = $src.querySelector('[type="submit"]');
            const $selects = $src.querySelectorAll('select');
            const $inputs = $src.querySelectorAll('input[type=text]');
            $selects.forEach(($select) => {
                const $wrapper = document.createElement('div');
                const $clonedSelect = $select.cloneNode(true);
                const $label = $select.previousElementSibling.cloneNode(true);
                $wrapper.classList.add('tail-select-wrapper');
                const value = $clonedSelect.value;
                initLabel(value, $wrapper);
                $clonedSelect.setAttribute('data-target', $clonedSelect.id);
                $clonedSelect.removeAttribute('id');
                $clonedSelect.addEventListener('change', (event) => {
                    const target = '#' + $clonedSelect.getAttribute('data-target');
                    const value = $clonedSelect.value;
                    initLabel(value, $wrapper);
                    console.log('event target value: ' + event.target.value);
                    if (event.target.value == '') {
                        for (var i = 0; i < $src.querySelector(target).options.length; i++) {
                            if ($src.querySelector(target).options[i].selected == true) {
                                $src.querySelector(target).options[i].selected = false;
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < $src.querySelector(target).options.length; i++) {
                            if ($src.querySelector(target).options[i].value == event.target.value) {
                                if ($src.querySelector(target).options[i].selected == true) {
                                    $src.querySelector(target).options[i].selected = false;
                                }
                                else {
                                    $src.querySelector(target).options[i].selected = true;
                                }
                            }
                        }
                    }
                    $submit.click();
                });
                $wrapper.appendChild($label);
                $wrapper.appendChild($clonedSelect);
                $filterGroup.appendChild($wrapper);
                let $filterOverride = $wrapper.closest('.view-filters-override');
                tail.select($clonedSelect, {
                    locale: 'it',
                    multiSelectAll: $clonedSelect.hasAttribute('multiple') || false,
                    search: $clonedSelect.children.length >= 5,
                    placeholder: ($label && $label.innerText) || '',
                })
                    .on('open', () => {
                    $wrapper.classList.add('open');
                    if ($filterOverride) {
                        $filterOverride.classList.add('open');
                    }
                })
                    .on('close', () => {
                    $wrapper.classList.remove('open');
                    if ($filterOverride) {
                        $filterOverride.classList.remove('open');
                    }
                });
            });
            $inputs.forEach(($input) => {
                const $id = $input.id;
                const $wrapper = document.createElement('div');
                const $clonedInput = $input.cloneNode(true);
                const $label = $input.previousElementSibling.cloneNode(true);
                $clonedInput.setAttribute('data-target', $clonedInput.id);
                $clonedInput.removeAttribute('id');
                $wrapper.appendChild($label);
                $wrapper.appendChild($clonedInput);
                if ($id.includes('date-')) {
                    $wrapper.classList.add('wrapper-datepicker', 'scroll-filter');
                    $filterGroup.appendChild($wrapper);
                    initScrollFilters();
                    flatpickr($clonedInput, {
                        altFormat: 'd/m/Y',
                        altInput: true,
                        dateFormat: 'Y-m-d',
                        locale: 'it',
                        onChange: function (selectedDates, dateStr, instance) {
                            const $dataTarget = $clonedInput.getAttribute('data-target');
                            let selectData = document.querySelector('#' + $dataTarget);
                            if ($id.includes('-max')) {
                                selectData.value = dateStr + ' 23:59:59';
                            }
                            else {
                                selectData.value = dateStr;
                            }
                            $submit.click();
                        },
                    });
                }
                else {
                    $wrapper.classList.add('wrapper-input-text', 'scroll-filter');
                    $filterGroup.appendChild($wrapper);
                    initScrollFilters();
                    $clonedInput.addEventListener('keypress', (e) => {
                        if (e.key === 'Enter') {
                            const target = $clonedInput.getAttribute('data-target');
                            const $target = document.querySelector('#' + target);
                            $target.value = $clonedInput.value;
                            $submit.click();
                        }
                    });
                }
            });
            $filterGroup.classList.add('is-active');
        }
    }
    function initLabel(value, $wrapper) {
        if (!value || value === 'All') {
            $wrapper.classList.add('has-all-selected', 'scroll-filter');
            initScrollFilters();
        }
        else {
            $wrapper.classList.remove('has-all-selected');
        }
    }
})(ViewFilters || (ViewFilters = {}));
